import { Overlay } from './overlay';
import { bindAll } from 'underscore'

export class PromoOverlay extends Overlay {
    constructor(options) {
        super(options);
    }

    initialize() {
        super.initialize();
        if(window.UrlManager.getParameter('promo')){
            if('overlay_' + window.UrlManager.getParameter('promo') == this.el.id){
                window.dispatchEvent(new CustomEvent('Overlay.open',
                    {
                        detail: {
                            id: this.el.id
                        }
                    }
                ));
            }
        }
    }
}

Me.views['PromoOverlay'] = PromoOverlay;
